var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalloutPattern = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 280,
  height: 206,
  fill: "none",
  viewBox: "0 0 280 206"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)",
  opacity: 0.3
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  width: 457,
  height: 207,
  x: -160,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 456.005,
  height: 206.263,
  x: -160,
  fill: "#D9D9D9",
  rx: 3.764
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#58B4FF",
  d: "M346.1 208.125c-43.888-21.944-38.954-58.517-44.407-76.668C270.53 19.027 208.464 10.63 201.193 10.63c-17.139-.542-47.523 7.585-49.86 43.346-3.117 50.931 66.22 47.68 91.93 68.27 17.659 14.087 29.604 45.513-2.597 38.74-38.954-15.171-84.659-10.565-103.616-2.438-31.942 13.816-43.368 31.697-46.485 35.489-3.116 3.793-42.848 60.685 5.454 107.553 37.915 36.844 89.593 10.836 109.848-18.422 12.206-17.61 20.776-34.948 30.384-50.39 37.915-47.681 83.101-16.526 95.046 5.689 18.179 33.864 31.163 50.932 47.523 39.553 16.621-11.378 14.543-46.326-32.72-69.895",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 179.618,
  cy: 40.563,
  r: 84.043,
  fill: "url(#c)",
  transform: "rotate(90 179.618 40.563)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 275.326,
  cy: 152.709,
  r: 63.44,
  stroke: "#DAE1E7",
  strokeWidth: 0.376,
  opacity: 0.6
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: 165.567,
  x2: 273.735,
  y1: 81.657,
  y2: 150.588,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B3DDFF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B3DDFF"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M-160 0h456.005v206.263H-160z"
})))));
export { SvgCalloutPattern as ReactComponent };
export default "data:image/svg+xml;base64,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";